import { Card, CardContent, Grid, Paper } from "@mui/material";
import React, { useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { callAPI, getLocalValue, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import {
  HeaderList,
  IHeaderListActions,
} from "../../Components/Header/HeaderList";

export const ChangePassword: React.FC<any> = React.memo((props) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { isSubmitSuccessful },
  } = useForm();
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const [isSubmitted, setIsSubmited] = useState(false);

  // Watch password and confirm password fields
  const password = useWatch({ control, name: "newPassword" });
  const confirmPassword = useWatch({ control, name: "confirmpassword" });

  const handleData = async (data: any) => {
    try {
      setLoading(true);
      let request = {
        userId: getLocalValue(LoacalVariables.UserId),
        oldPassword: data?.oldPassword,
        newPassword: data?.newPassword,
      };
      setIsSubmited(true);
      const response = await callAPI(
        "Auth/change-password",
        Method.POST,
        request
      );
      if (response) {
        showMessage(
          response?.message,
          response.isSuccess === true ? "success" : "error"
        );
        if (response.isSuccess === true) {
          navigate("/home");
        }
      }
    } catch (error) {
    } finally {
      setIsSubmited(false);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/");
  };


  // Determine if passwords match for real-time feedback
  const passwordsMatch = password === confirmPassword;

  const actions: IHeaderListActions[] = [
    {
      type: "button",
      text: "Cancel",
      size: "small",
      onClick: handleCancel,
      variant: "outlined",
      color: "primary",
    },
    {
      type: "button",
      text: "Save",
      loading: loading,
      size: "small",
      onClick: handleSubmit(handleData),
      buttonType: "submit",
      variant: "outlined",
      color: "primary",
    },
  ];

  return (
    <>
      <HeaderList
        title={"Change Password"}
        type="card"
        position="relative"
        actions={actions}
        isBackButton={true}
        url="/"
      />

      {
        <Card>
          <CardContent>
            <form onSubmit={handleSubmit(handleData)}>
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12}>
                  <WSTextField
                    control={control}
                    id="oldPassword"
                    {...register("oldPassword", {
                      required: "Old Password is required",
                    })}
                    name="oldPassword"
                    label="Old Password *"
                    type={TextType.Password}
                    maxLength={40}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    control={control}
                    id="newPassword"
                    {...register("newPassword", {
                      required: "New Password is required",
                    })}
                    name="newPassword"
                    label="New Password *"
                    type={TextType.Password}
                    maxLength={40}
                    minLength={5}
                  />
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    control={control}
                    maxLength={40}
                    id="confirmpassword"
                    {...register("confirmpassword", {
                      required: "Please confirm your password",
                      validate: {
                        matchesPreviousPassword: value => {
                          return passwordsMatch || "Passwords do not match";
                        }
                      }
                    })}
                    name="confirmpassword"
                    label="Confirm Password *"
                    type={TextType.Password}
                  />

                  {!passwordsMatch && confirmPassword && <div style={{ color: '#d32f2f', fontSize: '0.75rem' }}>Passwords do not match</div>}
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      }
    </>
  );
});
